'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { Wrench, Building2, HardHat } from 'lucide-react';
import { isCapacitorNative, KIOSK_LOGIN_PATH } from '@/lib/capacitor-client';
import { useBrand } from '@/components/providers/BrandProvider';

export default function LoginChooser() {
  const router = useRouter();
  const brand = useBrand();

  useEffect(() => {
    if (isCapacitorNative()) {
      router.replace(KIOSK_LOGIN_PATH);
    }
  }, [router]);
  return (
    <div className="min-h-screen bg-[#f0f4f8] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/api/logo" alt={brand.name} className="h-14 w-auto mx-auto mb-4" />
          <p className="text-sm text-slate-500 mt-1">Pasirinkite prisijungimo būdą</p>
        </div>

        <div className="space-y-3">
          <Link
            href="/login/vadyba"
            className="card p-5 flex items-center gap-4 hover:shadow-md transition-shadow active:scale-[0.99]"
          >
            <div className="w-12 h-12 rounded-xl bg-[#1e3a5f] flex items-center justify-center shrink-0">
              <Building2 className="w-6 h-6 text-white" />
            </div>
            <div className="text-left">
              <p className="font-bold text-stone-900">Vadyba</p>
              <p className="text-xs text-slate-500 mt-0.5">El. paštas ir slaptažodis</p>
            </div>
          </Link>

          <Link
            href="/login/meistrai"
            className="card p-5 flex items-center gap-4 hover:shadow-md transition-shadow active:scale-[0.99]"
          >
            <div className="w-12 h-12 rounded-xl bg-emerald-600 flex items-center justify-center shrink-0">
              <HardHat className="w-6 h-6 text-white" />
            </div>
            <div className="text-left">
              <p className="font-bold text-stone-900">Meistrai</p>
              <p className="text-xs text-slate-500 mt-0.5">6 skaitmenų darbuotojo kodas</p>
            </div>
          </Link>
        </div>

        <a
          href="/idiegti"
          className="mt-6 flex items-center justify-center gap-2 w-full py-2.5 rounded-xl border border-emerald-200 bg-emerald-50 text-emerald-700 text-xs font-bold hover:bg-emerald-100 transition-colors"
        >
          Įsidiegti {brand.appName} programėlę telefone
        </a>
      </div>
    </div>
  );
}
